import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Button, Modal } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const RequestNotAllowedModal = ({ show, merchantSlug }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const onAccept = () => {
    navigate(`/${merchantSlug}`)
  }

  return (
    <Modal show={show} onClose={() => {}} size="m" blockOnClose>
      <Styles.Container>
        <h1>{t('Solicitud no permitida')}</h1>
        <p>
          {t('Lo sentimos pero esta solicitud ya no es válida. Reinicia el proceso de solicitud para completarla.')}
        </p>
        <Button fullWidth onClick={onAccept}>
          {t('Volver a empezar')}
        </Button>
      </Styles.Container>
    </Modal>
  )
}

export default RequestNotAllowedModal
